import React, { useEffect } from 'react'
import { getToken } from 'apollo/client'
import { refreshSession, signOut } from 'apollo/auth'
import { Col, Spin } from 'antd'
import { setToStorage } from 'utils/localStorage'
import config from 'constants/config'
import { Root, SignInContainer, SignInRow } from '../SignIn/styled'

const { OKTA_URL } = config

const Sso = () => {
  const existingToken = getToken()
  const urlParams = new URLSearchParams(window.location.search)
  const ssoToken = urlParams.get('refresh_token')

  const authByRefreshToken = async () => {
    try {
      if (existingToken) {
        await signOut(true)
      }
      const errorMessage = await refreshSession(true, false)
      if (typeof errorMessage === 'string') {
        throw new Error(errorMessage)
      } else {
        setTimeout(() => {
          window.location.replace('/')
        }, 3000)
      }
    } catch (error) {
      window.location.replace(`/sso-error?text=${error.message}`)
    }
  }

  useEffect(() => {
    if (ssoToken) {
      setToStorage('refresh')(ssoToken)
      authByRefreshToken()
    } else {
      window.location.replace(existingToken ? '/' : OKTA_URL)
    }
  }, [ssoToken])

  return (
    <Root>
      <SignInContainer>
        <SignInRow type="flex" align="middle" justify="center">
          <Col>
            <Spin spinning size="large" />
          </Col>
        </SignInRow>
      </SignInContainer>
    </Root>
  )
}

export default Sso
